import { AccountInfo } from "@azure/msal-browser";
import { RoleKey } from "../Constants";
import { consolelog } from "./consolelog";

export function getUserRole(activeUser: AccountInfo | null) {
    const idTokenClaims = activeUser?.idTokenClaims as { roles: string[] };

    if (idTokenClaims.roles.indexOf('OriginPick.Admin') > -1) {
        return 'OriginPick.Admin';
    } else if (idTokenClaims.roles.indexOf('OriginPick.Update') > -1) {
        return 'OriginPick.Update';
    } else if (idTokenClaims.roles.indexOf('OriginPick.Read') > -1) {
        return 'OriginPick.Read';
    }

    return null;
}

export function setUserRole(activeUser: AccountInfo | null) {
    if (activeUser !== null) {
        const idTokenClaims = activeUser?.idTokenClaims as { roles: string[] };
        sessionStorage.setItem(RoleKey.a85a8e6b348b4011a1ec1e78e9620782, JSON.stringify(idTokenClaims.roles));
    }
}

export function verifyUserAccess(accessType: string) {
    let hasScreenAccess: boolean = false;
    let hasButtonAccess: boolean = false;
    let roles: string[] = [];
    try {
        roles = JSON.parse(sessionStorage.getItem(RoleKey.a85a8e6b348b4011a1ec1e78e9620782) || "") as string[];
    } catch (error) {

    }
    switch (accessType) {
        case 'Write Off':
            if (roles.indexOf(RoleKey.a85a8e6b348b4013a1ec1e78e9620782) > -1 || roles.indexOf(RoleKey.a85a8e6b348b4023a1ec1e78e9620782) > -1) {
                hasScreenAccess = true;
            }
            break;
        case 'Purchase Order':
            if (roles.indexOf(RoleKey.a85a8e6b348b4043a1ec1e78e9620782) > -1) {
                hasScreenAccess = true;
            }
            if (roles.indexOf(RoleKey.a85a8e6b348b4013a1ec1e78e9620782) > -1 || roles.indexOf(RoleKey.a85a8e6b348b4023a1ec1e78e9620782) > -1) {
                hasScreenAccess = true;
                hasButtonAccess = true;
            }
            break;

        case 'Store Order':
            if (roles.indexOf(RoleKey.a85a8e6b348b4043a1ec1e78e9620782) > -1) {
                hasScreenAccess = true;
            }
            if (roles.indexOf(RoleKey.a85a8e6b348b4013a1ec1e78e9620782) > -1 || roles.indexOf(RoleKey.a85a8e6b348b4023a1ec1e78e9620782) > -1) {
                hasScreenAccess = true;
                hasButtonAccess = true;
            }
            break;

        case 'Journey':
            if (roles.indexOf(RoleKey.a85a8e6b348b4043a1ec1e78e9620782) > -1) {
                hasScreenAccess = true;
                hasButtonAccess = false;
            }
            if (roles.indexOf(RoleKey.a85a8e6b348b4013a1ec1e78e9620782) > -1 || roles.indexOf(RoleKey.a85a8e6b348b4023a1ec1e78e9620782) > -1) {
                hasScreenAccess = true;
                hasButtonAccess = true;
            }
            //Remove Edit, Save and Write off buttons
            break;

        case 'Loose Load Inventory':
            if (roles.indexOf(RoleKey.a85a8e6b348b4043a1ec1e78e9620782) > -1) {
                hasScreenAccess = true;
                hasButtonAccess = false;
            }
            if (roles.indexOf(RoleKey.a85a8e6b348b4013a1ec1e78e9620782) > -1 || roles.indexOf(RoleKey.a85a8e6b348b4023a1ec1e78e9620782) > -1) {
                hasScreenAccess = true;
                hasButtonAccess = true;
            }
            //Remove Edit and save buttons
            break;

        case 'Address':
            if (roles.indexOf(RoleKey.a85a8e6b348b4043a1ec1e78e9620782) > -1) {
                hasScreenAccess = true;
            }
            if (roles.indexOf(RoleKey.a85a8e6b348b4013a1ec1e78e9620782) > -1 || roles.indexOf(RoleKey.a85a8e6b348b4023a1ec1e78e9620782) > -1) {
                hasScreenAccess = true;
                hasButtonAccess = true;
            }
            break;

        case 'SKU Detail':
            if (roles.indexOf(RoleKey.a85a8e6b348b4043a1ec1e78e9620782) > -1) {
                hasScreenAccess = true;
            }
            if (roles.indexOf(RoleKey.a85a8e6b348b4013a1ec1e78e9620782) > -1 || roles.indexOf(RoleKey.a85a8e6b348b4023a1ec1e78e9620782) > -1) {
                hasScreenAccess = true;
                hasButtonAccess = true;
            }
            break;

        case 'Pallet Details':
            if (roles.indexOf(RoleKey.a85a8e6b348b4043a1ec1e78e9620782) > -1) {
                hasScreenAccess = true;
                hasButtonAccess = false;
            }
            if (roles.indexOf(RoleKey.a85a8e6b348b4013a1ec1e78e9620782) > -1 || roles.indexOf(RoleKey.a85a8e6b348b4023a1ec1e78e9620782) > -1) {
                hasScreenAccess = true;
                hasButtonAccess = true;
            }
            //Remove Edit, Save and Write off buttons
            break;

        case 'File Upload':
            if (roles.indexOf(RoleKey.a85a8e6b348b4043a1ec1e78e9620782) > -1) {
                hasScreenAccess = false;
            }
            if (roles.indexOf(RoleKey.a85a8e6b348b4013a1ec1e78e9620782) > -1 || roles.indexOf(RoleKey.a85a8e6b348b4023a1ec1e78e9620782) > -1) {
                hasScreenAccess = true;
                hasButtonAccess = true;
            }
            break;

        case 'Clear Down':
            if (roles.indexOf(RoleKey.a85a8e6b348b4043a1ec1e78e9620782) > -1) {
                hasScreenAccess = false;
            }
            if (roles.indexOf(RoleKey.a85a8e6b348b4013a1ec1e78e9620782) > -1) {
                hasScreenAccess = true;
                hasButtonAccess = true;
            }
            break;

        case 'Manage Contacts':
            if (roles.indexOf(RoleKey.a85a8e6b348b4043a1ec1e78e9620782) > -1) {
                hasScreenAccess = false;
            }
            if (roles.indexOf(RoleKey.a85a8e6b348b4013a1ec1e78e9620782) > -1 || roles.indexOf(RoleKey.a85a8e6b348b4023a1ec1e78e9620782) > -1) {
                hasScreenAccess = true;
                hasButtonAccess = true;
            }
            break;
        default:
            break;
    }
     consolelog(`Access Requested for:${accessType}`)
     consolelog(`Access Granted for:${accessType}:${hasScreenAccess}`)
    return {hasScreenAccess,hasButtonAccess}
}